class MobileStickyAtc extends HTMLElement {
  constructor() {
    super();

    this.innerWrapper = this.querySelector("[data-inner-wrapper]");
    this.inner = this.querySelector("[data-inner]");
    this.content = this.querySelector("[data-content]");
    this.swipeClose = this.querySelector("[data-swipe-close]");

    this.handleOpen = () => {
      this._open();
    };

    this.handleClose = (e) => {
      this._close();
    };

    if (this.swipeClose) {
      // Close on click for non-touch devices
      this.swipeClose.addEventListener("click", () => {
        if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
          this._toggle();
        }
      });

      this.swipeClose.addEventListener("touchstart", (e) => {
        this.touchstart = e.targetTouches[0].clientY;
        this.touchend = null;
        if (!this._isOpen) {
          window.lockScroll(this);
          this.content.style.display = null;
        }
      });

      this.addEventListener("touchmove", (e) => {
        if (!this.touchstart) return;

        this.touchend = e.targetTouches[0].clientY;

        if (this._isOpen) {
          this._setSwipeOffset(Math.max(0, this.touchend - this.touchstart));
        } else {
          this._setSwipeOffset(
            Math.max(
              this.content.scrollHeight * -1,
              this.touchend - this.touchstart
            )
          );
        }
      });

      this.addEventListener("touchend", () => {
        window.unlockScroll(this);

        if (this.touchend) {
          if (this._isOpen && this.touchend - this.touchstart > 30) {
            this._close();
            return;
          } else if (this.touchstart - this.touchend > 30) {
            this.style.setProperty(
              "--open-offset",
              `${this.swipeOffset * -1}px`
            );
            this._open();
            return;
          }
        }

        this._setSwipeOffset(0);
      });
    }

    this.lastWasMobile = this._isMobile;

    this.handleResize = () => {
      if (this.lastWasMobile && !this._isMobile) {
        this._close(true);
      }

      this.lastWasMobile = this._isMobile;
    };

    window.addEventListener("resize", this.handleResize);

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items within an old modal.
      if (!document.body.contains(e.target)) return;

      if (this._isOpen && !this.contains(e.target)) {
        this._close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this._isOpen && e.code.toUpperCase() === "ESCAPE") {
        this._close();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.handleKeyUp);
    document.addEventListener("mini-cart:open", this.handleClose);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.handleKeyUp);
    document.removeEventListener("mini-cart:open", this.handleClose);
    window.removeEventListener("resize", this.handleResize);
  }

  _toggle() {
    if (this._isOpen) {
      this._close();
    } else {
      this._open();
    }
  }

  _open() {
    this.content.style.display = null;
    window.openFullDimmer(this);

    const handleTransitionEnd = () => {
      this.removeEventListener("transitionend", handleTransitionEnd);
      this.innerWrapper.style.transition = "none";

      window.requestAnimationFrame(() => {
        this.style.removeProperty("--open-offset");
        this._setSwipeOffset(0);
        window.requestAnimationFrame(() => {
          this.innerWrapper.style.transition = null;
        });
      });
    };

    this.addEventListener("transitionend", handleTransitionEnd);

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this._isOpen = true;
      window.lockScroll(this);
      window.trapFocus(this);
    });
  }

  _close(force) {
    if (!this._isOpen) return;

    const handleTransitionEnd = () => {
      this.removeEventListener("transitionend", handleTransitionEnd);
      this.innerWrapper.scrollTop = 0;
      this.content.style.display = "none";
      window.removeTrapFocus(this.swipeClose);
      window.unlockScroll(this);
      this._isOpen = false;
      this.touchstart = null;
      this.touchend = null;

      this.innerWrapper.style.transition = "none";

      window.requestAnimationFrame(() => {
        this.innerWrapper.style.transform = null;
        this._setSwipeOffset(0);
        window.requestAnimationFrame(() => {
          this.innerWrapper.style.transition = null;
        });
      });
    };

    if (force) {
      handleTransitionEnd();
    } else {
      this.addEventListener("transitionend", handleTransitionEnd);
    }
    this.removeAttribute("open");
    this.innerWrapper.style.transform =
      "translateY(calc(100% - var(--swipe-offset, 0px)))";
    window.closeFullDimmer(this);
  }

  _setSwipeOffset(px) {
    this.swipeOffset = px;
    this.style.setProperty("--swipe-offset", `${px}px`);
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("mobile-sticky-atc")) {
  customElements.define("mobile-sticky-atc", MobileStickyAtc);
}
